import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from './utils/sentry'

// Initialize Sentry before rendering
initSentry()

// Handle chunk load errors (stale cache after deployment)
// This catches errors when old HTML references JS chunks that no longer exist
window.addEventListener('error', (event) => {
  const isChunkLoadError =
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk') ||
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes("is not a valid JavaScript MIME type")

  if (isChunkLoadError) {
    // Prevent infinite reload loops - only reload once per session
    const reloadKey = 'chunk_error_reload'
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true')
      window.location.reload()
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
